import React, {Component} from 'react';
import {useSpring, animated} from 'react-spring'
import {Button} from "react-bootstrap";

const isMobile = window.innerWidth <= 500;

let styleSide = {
    color: "white",
    fontWeight: "bold",
    fontSize: isMobile ? 13 : 16,
    position: "fixed",
    right: "1.2rem",
    bottom: isMobile ? "60%" : "60%",
};

let phantom = {
    display: 'block',
    height: '6vh',
    width: '100%',
};


class GibSideBarInternal extends Component{

    render() {
        return (
            <div>
                <div style={phantom}/>
                <div style={styleSide} >
                    <style type="text/css">
                        <style type="text/css">
                            {`
                        .btn-rotated {
                          background-color: #000000BF;
                          color: white;
                          border-radius: 0rem;
                          // transform: rotate(-90deg)
                        }
                        .btn-xxl {
                          font-weight: bold;
                        }

                        `}
                        </style>
                    </style>
                    <Button
                        style={{fontSize: isMobile ? '1.2rem': '1.5rem'}}
                        href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=4M5H5DRRD8WNQ&source=url"
                        variant="rotated"
                        size="xxl" block>
                        WESPRZYJ
                    </Button>
                </div>
            </div>
        );
    }
}

function GibSideBar() {
    const animProps = useSpring({opacity: 1, from: {opacity: 0}});
    return (
        <animated.div style={animProps}>
            <GibSideBarInternal/>
        </animated.div>
    )
}

export default GibSideBar;